var SubHeroPage = (function () {
  

  var $stackedHeroes;

  function init() {
    $stackedHeroes = $('.acr-sub-page-hero-stacked');

    $(document).off('SubHeroPage/imageLoad', imageLoad)
      .on('SubHeroPage/imageLoad', imageLoad);

    // Unfortunately, the image sometimes don't get the resize instruction
    // so we need to call this every so often
    setInterval(imageLoad, 1000);
  }

  function imageLoad() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      $stackedHeroes.each(function (i, hero) {
        $(hero).css({
          zoom: '1',
          'background-image': '',
          height: 'auto',
        });
      });
    }
  }

  return {
    init: init,
  };
}());
